wbApp.factory('orderSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Order = $resource('/restapi/orders/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/orders/:id' },
            'insert': { method: 'POST', url: '/restapi/orders' }
        });

        var itemTypes;

        function createNew()
        {
            return {
                id: null,
                userId: null,
                studentIds: null,
                isNotRegisteredUser: false,
                publicNotes: null,
                orderStatus: 0,
                auditEvents: null,
                notRegisteredUserInfo: null,
                rents: null
            };
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                Order,
                model);
        }

        function getById(orderId) {
            return repositorySvc.customGet('getById', Order, { id: orderId });
        }



        return {
            createNew: createNew,
            getById: getById,
            insert: insert,
        }
    }
]);